// Import translation
import i18n from 'i18next';

export const select_articles_types = [
	{
		name: i18n.t('articles:types.article'),
		value: 'article'
	}
];
